<template>
  <div class="bienvenida-page">
    <!-- Fondo fijo -->
    <div class="background-fixed"></div>
    <div class="white-overlay"></div>

    <!-- Ornamento superior -->
    <div class="ubicacion-linea">
      <div ref="lineaDecorativa" class="linea-decorativa"></div>
    </div>

    <!-- Contenido principal -->
    <div class="bienvenida-container">
      <div class="contenido-bienvenida">
     
        <!-- Versículo (texto central) -->
        <div class="versiculo-container" ref="versiculoTextRef">
          <p class="versiculo-texto">
           Hoy dejo atrás una etapa para comenzar un nuevo capítulo en mi vida.   <br>
Con el alma llena de gratitud y el corazón emocionado, quiero celebrar mis XV años.<br>
Gracias a mis padres, que con amor, guía y paciencia han sido el mayor regalo en mi camino.<br>
          </p>
        </div>
      <p class="versiculo-referencia-fija" ref="versiculoRef"></p>

        <!-- Nombre decorativo -->
      
      </div>

      <!-- 👉 Referencia “Proverbios 3:5-6” en esquina inferior-derecha -->
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { gsap } from 'gsap';

export default {
  name: 'BienvenidaPage',
  setup() {
    const mensaje = ref(
     
    );

    const mensajeRef = ref(null);
    const versiculoTextRef = ref(null);
    const versiculoRef = ref(null);
    const nombreRef = ref(null);

    const animateOnScroll = (el, anim) => {
      const obs = new IntersectionObserver(
        ([e]) => { if (e.isIntersecting) { anim(); obs.unobserve(el); } },
        { threshold: 0.3 }
      );
      obs.observe(el);
    };

    onMounted(() => {
      if (mensajeRef.value)
        animateOnScroll(mensajeRef.value, () =>
          gsap.fromTo(mensajeRef.value, { opacity: 0, y: 50 },
            { opacity: 1, y: 0, duration: 1.2, ease: 'power3.out' }));

      if (versiculoTextRef.value)
        animateOnScroll(versiculoTextRef.value, () =>
          gsap.fromTo(versiculoTextRef.value, { opacity: 0, y: 40 },
            { opacity: 1, y: 0, duration: 1.2, ease: 'power2.out' }));

      if (nombreRef.value)
        animateOnScroll(nombreRef.value, () =>
          gsap.fromTo(nombreRef.value, { opacity: 0, y: 30 },
            { opacity: 1, y: 0, duration: 1, ease: 'power2.out' }));

      /* La referencia fija se anima directamente */
      if (versiculoRef.value)
        gsap.fromTo(versiculoRef.value, { opacity: 0, y: 20 },
          { opacity: 1, y: 0, duration: 1.4, delay: 0.4, ease: 'power2.out' });
    });

    return { mensaje, mensajeRef, versiculoTextRef, versiculoRef, nombreRef };
  }
};
</script>

<style scoped>
/* Layout */
.bienvenida-page { position: relative; margin: 0px 0; overflow: hidden; }
.background-fixed { position: fixed; inset: 0; background:url('@/assets/fnn.jpg') center/cover; z-index:-3; }
.white-overlay    { position: fixed; inset: 0; background:rgba(255, 255, 255, 0.158); z-index:-2; }

.bienvenida-container { position: relative; padding: 40px 20px; display: flex; flex-direction: column; align-items:center; }

/* Mensaje */
.mensaje-bienvenida{ font:300 19px 'Josefin Sans',sans-serif; color:#28303e; white-space:pre-line; line-height:2; opacity:0;}

/* Versículo central */
.versiculo-container{margin-top:-20px; opacity:0; text-align:center; margin-bottom:25px;}
.versiculo-texto{ font:italic 18px 'Josefin Sans',sans-serif; line-height:1.8; color:#847d7d;}

/* Referencia fija */
.versiculo-referencia-fija{
  position:absolute; bottom:10px; right:15px;
  font:12px 'Poppins',sans-serif; color:#8c7e78; opacity:0;
}

/* Nombre con flores */
.nombre-con-flores{ display:flex; align-items:center; gap:15px; margin-bottom:10px;}
.flor-lateral{ width:40px; }
.nuevo-texto{ font:22px 'FeelingPassionate'; color:#c6949b; opacity:0; position:relative; }
.e-wrapper{ letter-spacing:-.35em; }
.e-con-acento{ color:#c6949b; letter-spacing:-.25em; margin-left:-2px;}
.falso-acento{ position:absolute; top:10px; left:0; font-size:.45em; color:#c6949b; transform:rotate(15deg);}
</style>
